import { Button, Grid, makeStyles } from "@material-ui/core";
import { IconPopper } from "../molecules/poppers/iconPopper";
import { useState } from "react";
import { useToggle } from "../../hooks/useToggle";

const useStyles = makeStyles(() => ({
    selectorContainer: {
        display: 'flex',
        justifyContent: 'flex-start',
        gap: '1rem',
        alignItems: 'center',
        height: '5rem'
    },
    iconChooseBtn: {
        background: '#3f4e5c',
        padding: '0px 4px',
        lineHeight: '2',
        height: 'max-content',
        color: '#ffffff',
        fontWeight: 500,
        textTransform: 'capitalize',
        fontSize: '13px',
        '&:hover': {
            background: '#3f4e5c'
        }
    },
    avatar: {
        width: '80px',
        height: '80px',
        background:  '#d7d7d7',
        borderRadius: '50%',
        padding: '1rem'
    },
    iconImage: {
        width: '100%'
    }
}))

export function IconSelector({isBlueprintCreate, selectedIcon, setSelectedIcon, defaultSearchTag, blueprint_id, slug}) {
    const classes = useStyles();    
    const [isIconModalOpen, toggleIconModal] = useToggle(false);

    const [anchorEl, setAnchorEl] = useState(null);

    const handleChooseIcon = (event) => {
        setAnchorEl(event.currentTarget)
        toggleIconModal()
    }

    return(
        <Grid className={classes.selectorContainer}>
            <div className={classes.avatar}>
                {
                    ((selectedIcon && selectedIcon !== '') || selectedIcon?.link || selectedIcon?.filePath) &&
                    <img className={`${classes.iconImage} icon_holder`} src={typeof selectedIcon === 'string' ? selectedIcon : undefined || selectedIcon?.link || selectedIcon?.filePath}/>
                }
            </div>
            <Button className={classes.iconChooseBtn} id="icon_select_button" onClick={handleChooseIcon}>{selectedIcon && selectedIcon !== '' ? 'Change Icon' : 'Add Icon'}</Button>

            <IconPopper isBlueprintCreate={isBlueprintCreate} id="clusterlet_icons" open={isIconModalOpen} selectedIcons={selectedIcon} setSelectedIcon={setSelectedIcon} setOpen={toggleIconModal} anchorEl={anchorEl} defaultSearchTag={defaultSearchTag} blueprint_id={blueprint_id} slug={slug} />
        </Grid>
    )
}